import * as React from 'react';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import classNames from 'classnames/bind';
import styles from './v4Result.module.scss';

const cx = classNames.bind(styles);

const V4Result = () => {
  const { accaResultStore } = useResultStore();
  const { accVideoResult } = accaResultStore;

  if (!accVideoResult) return null;

  const { unreliableYn, comment } = accVideoResult;
  const statusText = unreliableYn ? '영상 분석 실패' : '영상 분석 완료';

  return (
    <>
      <em className={cx('title')}>영상 종합 분석 결과</em>
      <div className={cx('resultArea')}>
        <div className={cx('statusBox', unreliableYn ? 'warning' : 'good')}>
          <span className={cx('statusText')}>{statusText}</span>
        </div>
        <p className={cx('desc')}>{comment}</p>
      </div>
    </>
  );
};

export default V4Result;
